<template>
    <div :style="style">
        <slot />
    </div>
</template>

<script>
export default {
    props: {
        unit: {
            type: Number,
            default: 1
        }
    },
    computed: {
        style() {
            return {
                padding: this.unit + 'rem' + ' 0'
            }
        }
    }
}
</script>